var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.182 18.905V7.083c0-.872-.342-1.694-.96-2.312L15.77 1.323a3.252 3.252 0 0 0-2.313-.96H4.545c-2.207 0-4 1.793-4 4V18.91c0 2.207 1.793 4 4 4h11.637c2.207 0 4-1.793 4-4v-.004zm-17.455 0V4.36c0-1.004.815-1.819 1.818-1.819h8.913c.291 0 .564.113.771.32l3.451 3.451c.207.208.32.48.32.771v11.822a1.819 1.819 0 0 1-1.818 1.818H4.545a1.819 1.819 0 0 1-1.818-1.818z",
    fill: "#E3D380"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.181 13.45h-4c-.6 0-1.09.491-1.09 1.091s.49 1.091 1.09 1.091h4c.6 0 1.091-.49 1.091-1.09 0-.6-.49-1.092-1.09-1.092zM12.181 7.632h-4c-.6 0-1.09.49-1.09 1.09 0 .6.49 1.092 1.09 1.092h4c.6 0 1.091-.491 1.091-1.091s-.49-1.091-1.09-1.091z",
    fill: "#E3D380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3Icon);
export default __webpack_public_path__ + "static/media/step3-icon.7d2cc59ca8bda43230f2241e947afb1b.svg";
export { ForwardRef as ReactComponent };